<template>
  <div class="audio-playback">
<!--    <audio ref="audioPlayer" @play="onAudioPlay" @pause="onAudioPause" @ended="onAudioEnded"-->
<!--           @error="onAudioError"></audio>-->
    <div class="panel">
      <div class="panel-header">
        <h2 class="panel-title"><i class="fas fa-volume-up"></i> 音频播放</h2>
        <div class="header-actions">
          <button class="btn btn-success" @click="startPlayback" :class="{ 'playing': isPlaying }">
            <i class="fas fa-play"></i> {{ isPlaying ? '停止播放' : '开始播放音频' }}
          </button>
        </div>
      </div>

      <div class="control-settings">
        <div class="setting-row">
          <div class="setting-item">
            <label>音频设备</label>
            <div class="custom-select" @click="toggleDeviceDropdown">
              <div class="custom-select-value">
                {{ getSelectedDeviceName }}
              </div>
              <i class="fas fa-chevron-down select-arrow"></i>
              <div v-if="showDeviceDropdown" class="custom-select-dropdown">
                <div
                    v-for="device in audioDevices"
                    :key="device.id"
                    class="dropdown-item"
                    :class="{ selected: selectedDevice === device.id }"
                    @click.stop="selectDevice(device.id)"
                >
                  {{ device.name }}
                </div>
              </div>
            </div>
          </div>

          <div class="setting-item">
            <label>音频文件夹</label>
            <div class="folder-select">

              <div class="file-dir">{{DirName || "请点击右侧选择" }}</div>


              <button class="btn btn-sm btn-secondary" @click="selectFolder">选择</button>
            </div>
          </div>

          <div class="setting-item">
            <label>播放模式</label>
            <div class="custom-select" @click="togglePlayModeDropdown">
              <div class="custom-select-value">
                {{ getPlayModeName }}
              </div>
              <i class="fas fa-chevron-down select-arrow"></i>
              <div v-if="showPlayModeDropdown" class="custom-select-dropdown">
                <div
                    v-for="mode in playModes"
                    :key="mode.value"
                    class="dropdown-item"
                    :class="{ selected: playMode === mode.value }"
                    @click.stop="selectPlayMode(mode.value)"
                >
                  {{ mode.label }}
                </div>
              </div>
            </div>
          </div>

          <!--          <div class="setting-item">
                      <label>播放间隔</label>
                      <div class="interval-box">
                        <label class="switch-mini">
                          <input type="checkbox" v-model="randomIntervalEnabled" class="switch-checkbox">
                          <span class="switch-slider"></span>
                        </label>
                        <div ref="intervalInputs" class="interval-inputs" :class="{ active: randomIntervalEnabled }">
                          <input type="number" v-model="minInterval" class="interval-input" :disabled="!randomIntervalEnabled" min="1">
                          <span class="interval-text">到</span>
                          <input type="number" v-model="maxInterval" class="interval-input" :disabled="!randomIntervalEnabled" min="1">
                          <span class="interval-text">秒</span>
                        </div>

                      </div>
                    </div>-->
        </div>
      </div>

      <!-- 效果设置 -->
      <div class="effects-settings">
        <div class="effects-header">
          <div class="effects-actions">
            <button class="btn btn-sm btn-primary" @click="saveEffects">保存当前特效</button>
            <button class="btn btn-sm btn-secondary" @click="resetEffects">重置特效</button>
            <button class="btn btn-sm btn-secondary" @click="toggleAllEffects">
              {{ allEffectsSelected ? '取消全选' : '全选特效' }}
            </button>
          </div>
          <div v-if="waveformSupported" class="waveform-box">
            <canvas ref="waveformCanvas" class="waveform-canvas"></canvas>
          </div>
          <div class="effects-intensity">
            <span class="intensity-label">强度:</span>
            <label class="radio-label"><input type="radio" v-model="intensity" value="light"> 轻微</label>
            <label class="radio-label"><input type="radio" v-model="intensity" value="medium"> 中等</label>
            <label class="radio-label"><input type="radio" v-model="intensity" value="aggressive"> 激进</label>
            <label class="radio-label"><input type="radio" v-model="intensity" value="random"> 随机</label>
          </div>
        </div>

        <div class="effects-list">
          <div class="effects-table">
            <div v-for="i in Math.ceil(effects.length / 2)" :key="i" class="effects-group">
              <div class="effects-group-header">
                <input type="checkbox" :checked="isGroupEnabled(i)" @change="toggleGroup(i, $event.target.checked)">
                <span class="effects-group-title">{{ effects[(i - 1) * 2]?.name || '' }}</span>
              </div>
              <div class="table-row" v-if="effects[(i-1)*2]">
                <div class="col-checkbox"><input type="checkbox" v-model="effects[(i-1)*2].enabled"
                                                 @change="onEffectChanged"></div>
                <div class="col-name">{{ effects[(i - 1) * 2].name }}</div>
                <div class="col-value"><input type="number" v-model.number="effects[(i-1)*2].min" class="effect-input"
                                              step="0.01" @input="onEffectChanged"></div>
                <div class="col-value"><input type="number" v-model.number="effects[(i-1)*2].max" class="effect-input"
                                              step="0.01" @input="onEffectChanged"></div>
                <div class="col-effect">
                  <input type="range" v-model.number="effects[(i-1)*2].current"
                         :min="Math.min(Number(effects[(i-1)*2].min), Number(effects[(i-1)*2].max))"
                         :max="Math.max(Number(effects[(i-1)*2].min), Number(effects[(i-1)*2].max))" step="0.01"
                         class="effect-slider" @input="onEffectChanged">
                </div>
              </div>
              <div class="table-row" v-if="effects[(i-1)*2 + 1]">
                <div class="col-checkbox"><input type="checkbox" v-model="effects[(i-1)*2 + 1].enabled"
                                                 @change="onEffectChanged"></div>
                <div class="col-name">{{ effects[(i - 1) * 2 + 1].name }}</div>
                <div class="col-value"><input type="number" v-model.number="effects[(i-1)*2 + 1].min"
                                              class="effect-input" step="0.01" @input="onEffectChanged"></div>
                <div class="col-value"><input type="number" v-model.number="effects[(i-1)*2 + 1].max"
                                              class="effect-input" step="0.01" @input="onEffectChanged"></div>
                <div class="col-effect">
                  <input type="range" v-model.number="effects[(i-1)*2 + 1].current"
                         :min="Math.min(Number(effects[(i-1)*2 + 1].min), Number(effects[(i-1)*2 + 1].max))"
                         :max="Math.max(Number(effects[(i-1)*2 + 1].min), Number(effects[(i-1)*2 + 1].max))" step="0.01"
                         class="effect-slider" @input="onEffectChanged">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 添加/编辑音频弹窗 -->
      <div class="modal" v-if="showAudioModal">
        <div class="modal-content">
          <div class="modal-header">
            <h3>{{ editingAudio ? '编辑音频' : '添加音频' }}</h3>
            <button class="close-modal" @click="closeAudioModal">&times;</button>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <label>音频名称</label>
              <input type="text" v-model="currentAudio.name" placeholder="请输入音频名称" class="form-input">
            </div>
            <div class="form-group">
              <label>音频文件</label>
              <input type="file" accept="audio/*" @change="handleFileSelect" class="form-input">
              <div v-if="currentAudio.fileName" class="file-info">{{ currentAudio.fileName }}</div>
            </div>
            <div class="form-group">
              <label>时长</label>
              <input type="text" v-model="currentAudio.duration" placeholder="00:00" class="form-input">
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn btn-secondary" @click="closeAudioModal">取消</button>
            <button class="btn btn-primary" @click="saveAudio">保存</button>
          </div>
        </div>
      </div>

      <!-- 新增播放组弹窗 -->
      <div class="modal" v-if="showGroupModal">
        <div class="modal-content">
          <div class="modal-header">
            <h3>新增播放组</h3>
            <button class="close-modal" @click="showGroupModal = false">&times;</button>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <label>播放组名称</label>
              <input type="text" v-model="newGroupName" placeholder="请输入播放组名称" class="form-input">
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn btn-secondary" @click="showGroupModal = false">取消</button>
            <button class="btn btn-primary" @click="saveGroup">保存</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {getRandomInt} from "@/utils/function";

export default {
  name: 'AudioPlayback',
  data() {
    const defaultEffects = [
      {name: '语速变化 (x)', enabled: false, min: 0.2, max: 2, current: 1},
      {name: '语速变化 (半音)', enabled: false, min: 0.5, max: 2, current: 1},
      {name: '音调变化 (半音)', enabled: false, min: -12, max: 12, current: 0},
      {name: '30Hz均衡 (dB)', enabled: false, min: -20, max: 20, current: 0},
      {name: '50Hz均衡 (dB)', enabled: false, min: -20, max: 20, current: 0},
      {name: '80Hz均衡 (dB)', enabled: false, min: -20, max: 20, current: 0},
      {name: '200Hz均衡 (dB)', enabled: false, min: -20, max: 20, current: 0},
      {name: '600Hz均衡 (dB)', enabled: false, min: -20, max: 20, current: 0},
      {name: '1kHz均衡 (dB)', enabled: false, min: -20, max: 20, current: 0},
      {name: '4kHz均衡 (dB)', enabled: false, min: -20, max: 20, current: 0},
      {name: '8kHz均衡 (dB)', enabled: false, min: -20, max: 20, current: 0},
      {name: '10kHz均衡 (dB)', enabled: false, min: -20, max: 20, current: 0},
      {name: '12kHz均衡 (dB)', enabled: false, min: -20, max: 20, current: 0},
      {name: '梅尔噪声干扰 (dB)', enabled: false, min: 3.94, max: 5.06, current: 4.5},
      {name: '梅尔频率抖动 (Hz)', enabled: false, min: 7.46, max: 9.54, current: 8.5},
      {name: '梅尔频谱滤波 (dB)', enabled: false, min: 0.736, max: 0.864, current: 0.8},
      {name: '梅尔谱滤波 (dB)', enabled: false, min: 0.736, max: 0.864, current: 0.8},
      {name: '压缩阈值 (dB)', enabled: false, min: -60, max: 0, current: 0},
      {name: '压缩比率 (x)', enabled: false, min: 1, max: 20, current: 1}
    ].map(e => ({...e, baseMin: e.min, baseMax: e.max}))
    return {
      selectedGroup: 'default',
      groups: [],
      showDeviceDropdown: false,
      showFolderDropdown: false,
      showPlayModeDropdown: false,
      playMode: 'single-order',
      playModes: [
        {value: 'single-order', label: '单文件夹顺序播放'},
        {value: 'single-random', label: '单文件夹随机播放'},
        {value: 'multi-order', label: '多文件夹顺序播放'},
        {value: 'multi-random', label: '多文件夹随机播放'}
      ],
      randomIntervalEnabled: false,
      minInterval: 30,
      maxInterval: 60,
      autoPlay: false,
      loopPlay: false,
      playOnStart: false,
      selectAll: false,
      intensity: 'light',
      selectAllEffectsChecked: false,
      effects: JSON.parse(JSON.stringify(defaultEffects)),
      defaultEffects: JSON.parse(JSON.stringify(defaultEffects)),
      isHydratingEffects: false,
      isApplyingIntensityRanges: false,
      currentPage: 1,
      pageSize: 5,
      showAudioModal: false,
      showGroupModal: false,
      newGroupName: '',
      editingAudio: null,
      currentAudio: {
        name: '',
        fileName: '',
        duration: '00:00'
      },
      selectedDevice: 'default',
      audioDevices: [],
      audioContext: null,
      audioSource: null,
      gainNode: null,
      waveShaperNode: null,
      lastShaperAmount: null,
      currentAudioElement: null,
      effectUpdateTimer: null,
      effectRandomizeTimer: null,
      randomizeIntervalMs: 1000,
      effectRandomWalk: {},
      activeFilters: [],
      compressorNode: null,
      analyserNode: null,
      waveformSourceNode: null,
      waveformTapGainNode: null,
      waveformTapConnected: false,
      waveformRafId: null,
      waveformData: null,
      waveformSupported: false,
      waveformRetryTimer: null,
      waveformRetryCount: 0,
      intervalInputsWidth: 0,
      nextPauseAtMs: 0,
      pauseUntilMs: 0,
      effectsRoutingKey: '',
      selectedFolder: '',
      audioFolders: [],
      audios: [],
      shuffledAudios: [],
      shuffledIndex: 0,
      isPlaying: false,
      currentAudioIndex: 0,
      currentDirIndex: 0,
      playbackTimer: null,
      currentlyPlaying: null,
      audioList: {},
      DirName:"",
    }
  },
  watch: {
    selectedDevice(newDevice, oldDevice) {
      const audioPlayer = this.$store.state.fragmentsAudio
      if (audioPlayer) {
        if (newDevice === 'default') {
          audioPlayer.setSinkId('').catch(err => {
            console.warn('无法重置音频设备:', err)
          })
        } else {
          audioPlayer.setSinkId(newDevice).catch(err => {
            console.warn('无法设置音频设备:', err)
          })
        }
      }

      if (this.audioContext && this.audioContext.setSinkId) {
        if (newDevice === 'default') {
          this.audioContext.setSinkId('').catch(err => {
            console.warn('无法重置音频上下文设备:', err)
          })
        } else {
          this.audioContext.setSinkId(newDevice).catch(err => {
            console.warn('无法设置音频上下文设备:', err)
          })
        }
      }
    },
    intensity() {
      if (this.isHydratingEffects) return
      this.applyIntensity()
      if (this.hasEnabledEffects() && (this.isPlaying || this.isAudioActive())) this.startEffectRandomizeLoop()
      else this.stopEffectRandomizeLoop()
    }
  },
  computed: {
    getSelectedDeviceName() {
      const device = this.audioDevices.find(d => d.id === this.selectedDevice)
      return device ? device.name : '默认音频设备'
    },
    getSelectedFolderName() {
      const folder = this.audioFolders.find(f => f.id === this.selectedFolder)
      return folder ? folder.name : '请选择文件夹'
    },
    getPlayModeName() {
      const mode = this.playModes.find(m => m.value === this.playMode)
      return mode ? mode.label : '单文件夹顺序播放'
    },
    filteredAudios() {
      return this.audios.slice((this.currentPage - 1) * this.pageSize, this.currentPage * this.pageSize)
    },
    totalPages() {
      return Math.ceil(this.audios.length / this.pageSize)
    },
    allEffectsSelected() {
      return this.effects.length > 0 && this.effects.every(effect => effect.enabled)
    },

  },
  mounted() {
    if(!this.$store.state.fragmentsAudio){
      this.$store.commit("setFragmentsAudio",new Audio());
    }

    this.loadEffects()
    this.waveformSupported = !!(this.$store.state.fragmentsAudio && (this.$store.state.fragmentsAudio.captureStream || this.$store.state.fragmentsAudio.mozCaptureStream))
    this.getAudioDevices()

  },
  methods: {
    async getAudioDevices(){

      try{
        if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
          alert('您的浏览器不支持音频设备访问功能，请使用现代浏览器。')
          this.inputDevices = [{deviceId: 'default', label: '默认输入设备'}]
          this.outputDevices = [{deviceId: 'default', label: '默认输出设备'}]

          this.$store.commit("setChannelConfig", {
            inputDeviceId: 'default',
            outputDeviceId: 'default'
          })

          return
        }
        const stream = await navigator.mediaDevices.getUserMedia({audio: true})
        stream.getTracks().forEach(track => track.stop())
        const devices = await navigator.mediaDevices.enumerateDevices()
        this.initAudioDevices()
      }catch (e){}


    },
    isAudioActive() {
      const audio = this.$store.state.fragmentsAudio
      return !!(audio && audio.src && !audio.paused && !audio.ended)
    },
    updateIntervalInputsWidth() {
      const el = this.$refs.intervalInputs
      if (el && el.offsetWidth) {
        this.intervalInputsWidth = el.offsetWidth
      }
    },
    onAudioPlay() {
      this.waveformRetryCount = 0
      this.waveformSourceNode = null
      this.waveformTapConnected = false
      this.ensureWaveformAnalyser()
      if (this.hasEnabledEffects()) {
        this.ensureEffectsRouting()
        this.startEffectUpdateLoop()
      }
    },
    onAudioPause() {
      if (!this.isPlaying) {
        this.stopWaveformLoop()
        this.stopEffectUpdateLoop()
        this.stopEffectRandomizeLoop()
      }
    },
    ensureWaveformAnalyser() {
      if (!this.waveformSupported) return
      const audio = this.$store.state.fragmentsAudio
      if (!audio) return
      if (!this.audioContext) {
        this.audioContext = new (window.AudioContext || window.webkitAudioContext)()
      }
      if (this.audioContext.state === 'suspended') {
        this.audioContext.resume().catch(() => {
        })
      }
      if (!this.analyserNode) {
        this.analyserNode = this.audioContext.createAnalyser()
        this.analyserNode.fftSize = 2048
        this.analyserNode.smoothingTimeConstant = 0.6
        this.waveformData = new Uint8Array(this.analyserNode.fftSize)
      }
      if (!this.waveformSourceNode) {
        const stream = audio.captureStream ? audio.captureStream() : (audio.mozCaptureStream ? audio.mozCaptureStream() : null)
        if (!stream) {
          if (this.ensureWaveformTapFromGain()) {
            this.startWaveformLoop()
            return
          }
          this.scheduleWaveformRetry()
          return
        }
        const tracks = typeof stream.getAudioTracks === 'function' ? stream.getAudioTracks() : []
        if (!tracks || tracks.length === 0) {
          if (this.ensureWaveformTapFromGain()) {
            this.startWaveformLoop()
            return
          }
          this.scheduleWaveformRetry()
          return
        }
        this.waveformSourceNode = this.audioContext.createMediaStreamSource(stream)
        this.waveformSourceNode.connect(this.analyserNode)
      }
      this.startWaveformLoop()
    },
    ensureWaveformTapFromGain() {
      if (!this.audioContext || !this.gainNode || !this.analyserNode) return false
      if (this.waveformTapConnected) return true
      if (!this.waveformTapGainNode) {
        this.waveformTapGainNode = this.audioContext.createGain()
        this.waveformTapGainNode.gain.value = 0
      }
      try {
        this.gainNode.connect(this.analyserNode)
      } catch (e) {
        return false
      }
      try {
        this.analyserNode.connect(this.waveformTapGainNode)
        this.waveformTapGainNode.connect(this.audioContext.destination)
      } catch (e) {
        return false
      }
      this.waveformTapConnected = true
      return true
    },
    scheduleWaveformRetry() {
      if (this.waveformRetryTimer) return
      if (this.waveformRetryCount >= 20) return
      this.waveformRetryCount += 1
      this.waveformRetryTimer = setTimeout(() => {
        this.waveformRetryTimer = null
        this.ensureWaveformAnalyser()
      }, 120)
    },
    startWaveformLoop() {
      if (!this.waveformSupported) return
      if (this.waveformRafId) return
      const canvas = this.$refs.waveformCanvas
      if (!canvas || !this.analyserNode || !this.waveformData) return
      const ctx = canvas.getContext('2d')
      if (!ctx) return

      const render = () => {

        this.waveformRafId = requestAnimationFrame(render)
        const c = this.$refs.waveformCanvas
        if (!c) return
        const dpr = window.devicePixelRatio || 1
        const displayWidth = Math.max(1, c.clientWidth || 120)
        const displayHeight = Math.max(1, c.clientHeight || 28)
        const targetWidth = Math.floor(displayWidth * dpr)
        const targetHeight = Math.floor(displayHeight * dpr)
        if (c.width !== targetWidth || c.height !== targetHeight) {
          c.width = targetWidth
          c.height = targetHeight
        }

        const audioEl = this.$store.state.fragmentsAudio
        if (audioEl && !audioEl.paused) {
          this.analyserNode.getByteTimeDomainData(this.waveformData)
        } else {
          this.waveformData.fill(128)
        }

        ctx.clearRect(0, 0, c.width, c.height)
        ctx.lineWidth = Math.max(1, 1.5 * dpr)
        ctx.strokeStyle = 'rgba(34, 211, 238, 0.9)'
        ctx.beginPath()
        const sliceWidth = c.width / this.waveformData.length
        let x = 0
        for (let i = 0; i < this.waveformData.length; i++) {
          const v = this.waveformData[i] / 128.0
          const y = (v * c.height) / 2
          if (i === 0) ctx.moveTo(x, y)
          else ctx.lineTo(x, y)
          x += sliceWidth
        }
        ctx.lineTo(c.width, c.height / 2)
        ctx.stroke()
      }

      this.waveformRafId = requestAnimationFrame(render)
    },
    stopWaveformLoop() {
      if (this.waveformRafId) {
        cancelAnimationFrame(this.waveformRafId)
        this.waveformRafId = null
      }
      if (this.waveformRetryTimer) {
        clearTimeout(this.waveformRetryTimer)
        this.waveformRetryTimer = null
      }
      this.waveformRetryCount = 0
    },
    hasEnabledEffects() {
      return this.effects.some(e => e.enabled)
    },
    getEffectsRoutingKey() {
      return this.effects
          .filter(e => e.enabled)
          .map(e => e.name)
          .sort()
          .join('|')
    },
    makeShaperCurve(amount) {
      const a = Math.max(0, Math.min(0.999, Number(amount) || 0))
      const k = 2 * a / (1 - a)
      const samples = 44100
      const curve = new Float32Array(samples)
      for (let i = 0; i < samples; i++) {
        const x = (i / (samples / 2)) - 1
        curve[i] = ((1 + k) * x) / (1 + k * Math.abs(x))
      }
      return curve
    },
    onEffectChanged() {
      this.effects.forEach(effect => {
        let min = Number(effect.min)
        let max = Number(effect.max)
        if (!Number.isFinite(min)) min = 0
        if (!Number.isFinite(max)) max = 0
        if (min > max) {
          const tmp = min
          min = max
          max = tmp
          effect.min = min
          effect.max = max
        }
        const current = Number(effect.current)
        if (!Number.isFinite(current)) {
          effect.current = (min + max) / 2
        } else {
          if (current < min) effect.current = min
          if (current > max) effect.current = max
        }
        if (!this.isApplyingIntensityRanges) {
          effect.baseMin = min
          effect.baseMax = max
        }
      })
      this.persistEffects()
      if (!this.isPlaying && !this.isAudioActive()) return
      if (!this.hasEnabledEffects()) return
      if (!this.audioSource) {
        this.ensureEffectsRouting()
        this.effectsRoutingKey = this.getEffectsRoutingKey()
        return
      }

      const nextKey = this.getEffectsRoutingKey()
      if (nextKey !== this.effectsRoutingKey) {
        this.applyEffects()
        this.effectsRoutingKey = nextKey
      } else {
        this.updateEffectsInRealTime()
      }
    },
    ensureEffectsRouting() {
      if (!this.$store.state.fragmentsAudio) return
      if (!this.audioContext) {
        this.audioContext = new (window.AudioContext || window.webkitAudioContext)()
      }
      if (this.audioContext.state === 'suspended') {
        this.audioContext.resume().catch(() => {
        })
      }
      if (!this.audioSource) {
        try {
          this.audioSource = this.audioContext.createMediaElementSource(this.$store.state.fragmentsAudio)
        } catch (e) {
          return
        }
      }
      this.applyEffects()
      this.effectsRoutingKey = this.getEffectsRoutingKey()
      this.startEffectUpdateLoop()
    },
    persistEffects() {
      try {
        localStorage.setItem('audioPlayback.effects.v2', JSON.stringify({
          intensity: this.intensity,
          effects: this.effects
        }))
      } catch (e) {
      }
    },
    loadEffects() {
      try {
        const v2 = localStorage.getItem('audioPlayback.effects.v2')
        const v1 = localStorage.getItem('audioPlayback.effects.v1')
        const saved = v2 || v1
        if (!saved) return
        const fromV1 = !v2 && !!v1
        const parsed = JSON.parse(saved)
        this.isHydratingEffects = true
        if (parsed && Array.isArray(parsed.effects)) {
          this.effects = parsed.effects
              .filter(e => e && e.name !== '随机减速 (s)' && e.name !== '动态重塑因子 (x)' && e.name !== '随机停顿 (s)')
              .map(e => {
                const def = this.defaultEffects.find(d => d && d.name === e.name)
                const min = Number(e.min)
                const max = Number(e.max)
                const baseMinFromSaved = Number(e.baseMin)
                const baseMaxFromSaved = Number(e.baseMax)
                const baseMinFallback = def ? Number(def.baseMin) : min
                const baseMaxFallback = def ? Number(def.baseMax) : max
                return {
                  name: e.name,
                  enabled: !!e.enabled,
                  min,
                  max,
                  baseMin: Number.isFinite(baseMinFromSaved) ? baseMinFromSaved : baseMinFallback,
                  baseMax: Number.isFinite(baseMaxFromSaved) ? baseMaxFromSaved : baseMaxFallback,
                  current: (typeof e.current !== 'undefined' && e.current !== null)
                      ? Number(e.current)
                      : (typeof e.value !== 'undefined' && e.value !== null)
                          ? (min + (max - min) * (Number(e.value) / 100))
                          : ((min + max) / 2)
                }
              })
        }
        if (parsed && typeof parsed.intensity === 'string') {
          this.intensity = parsed.intensity
        }
        if (fromV1) {
          const toOriginalCurrent = (effect) => {
            const name = String(effect.name || '')
            const lo = Math.min(Number(effect.min), Number(effect.max))
            const hi = Math.max(Number(effect.min), Number(effect.max))
            if (name.includes('语速变化 (x)')) return 1
            if (name.includes('语速变化 (半音)')) return 1
            if (name.includes('音调变化 (半音)')) return 0
            if (name.includes('均衡')) return 0
            if (name.includes('压缩阈值')) return hi
            if (name.includes('压缩比率')) return 1
            if (name.includes('动态重塑')) return 0
            if (Number.isFinite(lo)) return lo
            return 0
          }
          this.effects = this.effects.map(e => ({
            ...e,
            enabled: false,
            current: toOriginalCurrent(e)
          }))
          this.intensity = 'light'
          this.persistEffects()
        }
        this.isHydratingEffects = false
      } catch (e) {
        this.isHydratingEffects = false
      }
    },
    applyIntensity() {
      const intensity = this.intensity
      const round = (v) => Number(Number(v).toFixed(3))
      const intensityKey = String(intensity || 'light')
      const genericFactor =
          intensityKey === 'light' ? 0.25 :
              intensityKey === 'medium' ? 0.6 :
                  intensityKey === 'aggressive' ? 1.0 :
                      1.0
      const ratioFactor =
          intensityKey === 'light' ? 0.1 :
              intensityKey === 'medium' ? 0.35 :
                  intensityKey === 'aggressive' ? 1.0 :
                      1.0
      const pauseFactor = genericFactor
      const thresholdFactor = genericFactor

      this.isApplyingIntensityRanges = true
      try {
        this.effects.forEach(effect => {
          const name = String(effect.name || '')
          let baseMin = Number(effect.baseMin)
          let baseMax = Number(effect.baseMax)
          if (!Number.isFinite(baseMin)) baseMin = Number(effect.min)
          if (!Number.isFinite(baseMax)) baseMax = Number(effect.max)
          if (!Number.isFinite(baseMin)) baseMin = 0
          if (!Number.isFinite(baseMax)) baseMax = 0
          const baseLo = Math.min(baseMin, baseMax)
          const baseHi = Math.max(baseMin, baseMax)

          let nextMin = baseLo
          let nextMax = baseHi

          if (intensityKey !== 'random') {
            if (name.includes('压缩阈值')) {
              nextMax = baseHi
              nextMin = baseHi - (baseHi - baseLo) * thresholdFactor
            } else if (name.includes('压缩比率')) {
              nextMin = baseLo
              nextMax = 1 + (baseHi - 1) * ratioFactor
            } else {
              const neutral =
                  name.includes('语速变化') ? 1 :
                      name.includes('音调变化') ? 0 :
                          name.includes('均衡') ? 0 :
                              (baseLo + baseHi) / 2
              const delta = (baseHi - baseLo) * genericFactor * 0.5
              nextMin = neutral - delta
              nextMax = neutral + delta
            }
            nextMin = Math.max(baseLo, Math.min(baseHi, nextMin))
            nextMax = Math.max(baseLo, Math.min(baseHi, nextMax))
            if (nextMin > nextMax) {
              const t = nextMin
              nextMin = nextMax
              nextMax = t
            }
          }

          effect.min = round(nextMin)
          effect.max = round(nextMax)

          const lo = Math.min(effect.min, effect.max)
          const hi = Math.max(effect.min, effect.max)

          if (intensityKey === 'random') {
            if (Number.isFinite(lo) && Number.isFinite(hi) && lo !== hi) {
              effect.current = round(Math.random() * (hi - lo) + lo)
            } else if (Number.isFinite(lo)) {
              effect.current = round(lo)
            }
          } else {
            const current = Number(effect.current)
            if (!Number.isFinite(current)) {
              effect.current = round((lo + hi) / 2)
            } else {
              if (current < lo) effect.current = round(lo)
              if (current > hi) effect.current = round(hi)
            }
          }
        })
      } finally {
        this.isApplyingIntensityRanges = false
      }

      this.persistEffects()
      if (this.audioContext && this.audioSource && this.effects.some(e => e.enabled)) {
        this.applyEffects()
      }
    },
    isGroupEnabled(groupIndex) {
      const start = (groupIndex - 1) * 2
      const indices = [start, start + 1].filter(i => this.effects[i])
      if (indices.length === 0) return false
      return indices.every(i => this.effects[i].enabled)
    },
    toggleGroup(groupIndex, enabled) {
      const start = (groupIndex - 1) * 2
      if (this.effects[start]) this.effects[start].enabled = enabled
      if (this.effects[start + 1]) this.effects[start + 1].enabled = enabled
      this.persistEffects()
      if (this.audioContext && this.audioSource && this.effects.some(e => e.enabled)) {
        this.applyEffects()
      }
    },
    toggleDeviceDropdown() {
      this.showDeviceDropdown = !this.showDeviceDropdown
      if (this.showDeviceDropdown) {
        this.showFolderDropdown = false
        this.showPlayModeDropdown = false
      }
    },
    toggleFolderDropdown() {
      this.showFolderDropdown = !this.showFolderDropdown
      if (this.showFolderDropdown) {
        this.showDeviceDropdown = false
        this.showPlayModeDropdown = false
      }
    },
    togglePlayModeDropdown() {
      this.showPlayModeDropdown = !this.showPlayModeDropdown
      if (this.showPlayModeDropdown) {
        this.showDeviceDropdown = false
        this.showFolderDropdown = false
      }
    },
    handleClickOutside(event) {
      if (!event.target.closest('.custom-select')) {
        this.showDeviceDropdown = false
        this.showFolderDropdown = false
        this.showPlayModeDropdown = false
      }
    },
    selectDevice(deviceId) {
      this.selectedDevice = deviceId
      this.showDeviceDropdown = false
    },
    selectFolderItem(folderId) {
      this.selectedFolder = folderId
      console.log(folderId);

      this.showFolderDropdown = false
    },
    selectPlayMode(mode) {
      this.playMode = mode
      this.showPlayModeDropdown = false
    },
    initAudioDevices() {
      if (navigator.mediaDevices && navigator.mediaDevices.enumerateDevices) {
        navigator.mediaDevices.enumerateDevices()
            .then(devices => {
              const audioOutputDevices = devices.filter(device => device.kind === 'audiooutput')
              if (audioOutputDevices.length > 0) {
                this.audioDevices = audioOutputDevices.map(device => ({
                  id: device.deviceId,
                  name: device.label || `音频设备 ${device.deviceId.slice(0, 8)}`
                }))
              } else {
                this.audioDevices = [{id: 'default', name: '默认音频设备'}]
              }
            })
            .catch(err => {
              console.warn('获取音频设备失败:', err)
              this.audioDevices = [{id: 'default', name: '默认音频设备'}]
            })
      } else {
        this.audioDevices = [{id: 'default', name: '默认音频设备'}]
      }
    },
    startPlayback() {
      if (this.isPlaying) {
        this.stopPlayback()
      } else {
        this.isPlaying = true
        this.currentAudioIndex = 0
        if (this.hasEnabledEffects()) {
          this.ensureEffectsRouting()
        }
        this.playNextAudio()
      }
    },
    stopPlayback() {
      this.isPlaying = false
      this.stopWaveformLoop()
      this.stopEffectUpdateLoop()
      this.stopEffectRandomizeLoop()
      if (this.playbackTimer) {
        clearTimeout(this.playbackTimer)
        this.playbackTimer = null
      }
      if (this.$store.state.fragmentsAudio) {
        this.$store.state.fragmentsAudio.pause()
        this.$store.state.fragmentsAudio.currentTime = 0
      }
    },
    playNextAudio() {
      if (!this.isPlaying) return
      if (this.audioList.length === 0) {
        this.$dialog.tips({
          message: "没有可用的音频文件，请先选择文件夹导入音频",
          type: "error"
        })
        this.stopPlayback()
        return
      }

      let audioToPlay

      switch (this.playMode) {
        case "single-order":
          this.currentDirIndex = 0
          var file = this.audioList[Object.keys(this.audioList)[0]]
          audioToPlay = file[this.currentAudioIndex % file.length];
          this.currentAudioIndex++
          break;
        case "single-random":
          this.currentDirIndex = 0
          var file = this.audioList[Object.keys(this.audioList)[0]]

          audioToPlay = file[getRandomInt(0, file.length - 1)];
          break;

        case "multi-order":

          if (this.currentDirIndex > Object.keys(this.audioList).length - 1) {
            this.currentDirIndex = 0;
          }

          var file = this.audioList[Object.keys(this.audioList)[this.currentDirIndex]];
          audioToPlay = file[getRandomInt(0, file.length - 1)];
          this.currentDirIndex++;

          break;

        case "multi-random":
          const num = getRandomInt(0, Object.keys(this.audioList).length - 1);

          var file = this.audioList[Object.keys(this.audioList)[num]];
          audioToPlay = file[getRandomInt(0, file.length - 1)];
          break;

      }

      this.currentlyPlaying = audioToPlay

      const audioPlayer = this.$store.state.fragmentsAudio

      if (audioPlayer) {
        if (this.selectedDevice && this.selectedDevice !== 'default') {
          audioPlayer.setSinkId(this.selectedDevice).then(() => {
            this.playAudioWithEffects(audioToPlay)
          }).catch(err => {
            console.warn('无法设置音频设备:', err)
            this.playAudioWithEffects(audioToPlay)
          })
        } else {
          audioPlayer.setSinkId('').then(() => {
            this.playAudioWithEffects(audioToPlay)
          }).catch(err => {
            console.warn('无法重置音频设备:', err)
            this.playAudioWithEffects(audioToPlay)
          })
        }
      }
    },
    playAudioWithEffects(audioToPlay) {
      const audioPlayer = this.$store.state.fragmentsAudio
      if (this.hasEnabledEffects()) {
        this.playNextWithEffects(audioToPlay)
      } else {
        audioPlayer.src = audioToPlay.url
        audioPlayer.play().catch(err => {
          const interval = this.getRandomInterval()
          this.playbackTimer = setTimeout(() => {
            this.playNextAudio()
          }, interval)
        })

        audioPlayer.addEventListener('play', () => {
          this.onAudioPlay();
        });

        audioPlayer.addEventListener('ended',()=>{
          this.playNextAudio()
        })

        audioPlayer.addEventListener('pause',()=>{
          this.onAudioPause()
        })
        audioPlayer.addEventListener('error',(e)=>{
          this.onAudioError(e)
        })


      }
    },
    shuffleArray(array) {
      for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]]
      }
      return array
    },
    playNextWithEffects(audio) {
      if (!this.audioContext) {
        this.audioContext = new (window.AudioContext || window.webkitAudioContext)()
      }

      if (this.audioContext.state === 'suspended') {
        this.audioContext.resume()
      }

      if (this.audioContext.setSinkId && this.selectedDevice && this.selectedDevice !== 'default') {
        this.audioContext.setSinkId(this.selectedDevice).catch(err => {
          console.warn('无法设置音频上下文设备:', err)
        })
      }

      if (!this.audioSource) {
        try {
          this.audioSource = this.audioContext.createMediaElementSource(this.$store.state.fragmentsAudio)
        } catch (e) {
          this.$store.state.fragmentsAudio.src = audio.url
          this.$store.state.fragmentsAudio.play().catch(() => {
          })
          return
        }
      }

      this.applyEffects()
      this.startEffectUpdateLoop()

      this.$store.state.fragmentsAudio.src = audio.url
      this.$store.state.fragmentsAudio.play().catch(err => {
        console.error('播放失败:', err)
        const interval = this.getRandomInterval()
        this.playbackTimer = setTimeout(() => {
          this.playNextAudio()
        }, interval)
      })
    },
    startEffectUpdateLoop() {
      this.stopEffectUpdateLoop()
      if (this.hasEnabledEffects()) this.startEffectRandomizeLoop()

      const updateLoop = () => {
        if (!this.$store.state.fragmentsAudio) return
        if (!this.isPlaying && !this.isAudioActive()) return

        this.updateEffectsInRealTime()
        this.effectUpdateTimer = setTimeout(updateLoop, 100)
      }

      updateLoop()
    },
    stopEffectUpdateLoop() {
      if (this.effectUpdateTimer) {
        clearTimeout(this.effectUpdateTimer)
        this.effectUpdateTimer = null
      }
    },
    startEffectRandomizeLoop() {
      this.stopEffectRandomizeLoop()
      if (!this.isPlaying && !this.isAudioActive()) return
      const randomizeLoop = () => {
        if (!this.isPlaying && !this.isAudioActive()) return
        this.randomizeEffectValues()
        this.effectRandomizeTimer = setTimeout(randomizeLoop, this.randomizeIntervalMs)
      }
      randomizeLoop()
    },
    stopEffectRandomizeLoop() {
      if (this.effectRandomizeTimer) {
        clearTimeout(this.effectRandomizeTimer)
        this.effectRandomizeTimer = null
      }
      this.effectRandomWalk = {}
    },
    randomizeEffectValues() {
      const enabledEffects = this.effects.filter(e => e.enabled)
      if (enabledEffects.length === 0) return
      const intensity = String(this.intensity || 'light')
      const intensityFactor =
          intensity === 'light' ? 0.25 :
              intensity === 'medium' ? 0.6 :
                  intensity === 'aggressive' ? 1.2 :
                      1.0
      const directionChangeChance =
          intensity === 'light' ? 0.08 :
              intensity === 'medium' ? 0.12 :
                  intensity === 'aggressive' ? 0.2 :
                      0.35

      enabledEffects.forEach(effect => {
        const min = Number(effect.min)
        const max = Number(effect.max)
        if (!Number.isFinite(min) || !Number.isFinite(max)) return
        if (min === max) {
          effect.current = min
          return
        }
        const lo = Math.min(min, max)
        const hi = Math.max(min, max)
        const range = hi - lo
        const baseStep = Math.max(range * 0.01, 0.01)
        const step = Math.min(baseStep * intensityFactor, Math.max(range * 0.2, 0.05))

        const key = String(effect.name || '')
        if (!this.effectRandomWalk[key]) {
          const direction = Math.random() < 0.5 ? -1 : 1
          this.effectRandomWalk[key] = {
            vel: direction * step * (0.5 + Math.random())
          }
        } else if (Math.random() < directionChangeChance) {
          const direction = Math.random() < 0.5 ? -1 : 1
          this.effectRandomWalk[key].vel = direction * step * (0.5 + Math.random())
        } else {
          const v = Number(this.effectRandomWalk[key].vel)
          if (Number.isFinite(v)) {
            const s = Math.abs(step)
            const next = Math.max(-s, Math.min(s, v))
            this.effectRandomWalk[key].vel = next
          }
        }

        const vel = Number(this.effectRandomWalk[key].vel) || step
        let current = Number(effect.current)
        if (!Number.isFinite(current)) current = (lo + hi) / 2
        current = current + vel

        if (current <= lo) {
          current = lo
          this.effectRandomWalk[key].vel = Math.abs(vel)
        } else if (current >= hi) {
          current = hi
          this.effectRandomWalk[key].vel = -Math.abs(vel)
        }

        // 确保 current 始终在 [lo, hi] 范围内
        current = Math.max(lo, Math.min(hi, current))

        effect.current = Number(current.toFixed(3))
      })
    },
    updateEffectsInRealTime() {
      const enabledEffects = this.effects.filter(e => e.enabled)
      if (enabledEffects.length === 0) return

      const audio = this.$store.state.fragmentsAudio
      if (!audio || !audio.src) return

      const currentTime = audio.currentTime
      const duration = audio.duration || 1
      const progress = duration > 0 ? currentTime / duration : 0

      const speedEffect = enabledEffects.find(e => e.name.includes('语速变化 (x)'))
      const speedSemiEffect = enabledEffects.find(e => e.name.includes('语速变化 (半音)'))
      const pitchEffect = enabledEffects.find(e => e.name.includes('音调变化 (半音)'))
      const shaperEffect = enabledEffects.find(e => e.name.includes('动态重塑'))

      let targetRate = 1.0

      if (speedEffect) {
        const rate = Number(speedEffect.current)
        if (Number.isFinite(rate)) {
          targetRate = Math.max(0.5, Math.min(2.0, rate))
        }
      }

      if (speedSemiEffect) {
        const rate = Number(speedSemiEffect.current)
        if (Number.isFinite(rate)) {
          targetRate *= Math.max(0.5, Math.min(2.0, rate))
        }
      }

      if (pitchEffect) {
        const semitone = Number(pitchEffect.current)
        if (Number.isFinite(semitone)) {
          const pitchRate = Math.pow(2, semitone / 12)
          targetRate *= pitchRate
        }
      }

      targetRate = Math.max(0.25, Math.min(2.0, targetRate))

      const currentRate = Number(audio.playbackRate) || 1
      const smoothedRate = currentRate + (targetRate - currentRate) * 0.25
      audio.playbackRate = smoothedRate

      if (this.compressorNode) {
        const thresholdEffect = enabledEffects.find(e => e.name.includes('压缩阈值'))
        if (thresholdEffect) {
          const threshold = Number(thresholdEffect.current)
          if (Number.isFinite(threshold)) {
            this.compressorNode.threshold.value = threshold
          }
        }
        const ratioEffect = enabledEffects.find(e => e.name.includes('压缩比率'))
        if (ratioEffect) {
          const ratio = Number(ratioEffect.current)
          if (Number.isFinite(ratio)) {
            this.compressorNode.ratio.value = ratio
          }
        }
      }

      if (this.waveShaperNode) {
        const amount = shaperEffect ? Math.max(0, Math.min(1, Number(shaperEffect.current) || 0)) : 0
        if (this.lastShaperAmount === null || Math.abs(amount - this.lastShaperAmount) > 0.005) {
          this.waveShaperNode.curve = this.makeShaperCurve(amount)
          this.waveShaperNode.oversample = '2x'
          this.lastShaperAmount = amount
        }
      }

      const freqBands = [
        {name: '30Hz均衡', freq: 30},
        {name: '50Hz均衡', freq: 50},
        {name: '80Hz均衡', freq: 80},
        {name: '200Hz均衡', freq: 200},
        {name: '600Hz均衡', freq: 600},
        {name: '1kHz均衡', freq: 1000},
        {name: '4kHz均衡', freq: 4000},
        {name: '8kHz均衡', freq: 8000},
        {name: '10kHz均衡', freq: 10000},
        {name: '12kHz均衡', freq: 12000}
      ]

      freqBands.forEach((band, index) => {
        const effect = enabledEffects.find(e => e.name.includes(band.name))
        if (effect && this.activeFilters[index]) {
          const baseGain = Number(effect.current)
          if (!Number.isFinite(baseGain)) return
          this.activeFilters[index].gain.value = baseGain
        }
      })
    },
    onAudioEnded() {
      if (!this.isPlaying) {
        this.stopWaveformLoop()
        this.stopEffectUpdateLoop()
        this.stopEffectRandomizeLoop()
        return
      }

      const interval = this.getRandomInterval()
      this.playbackTimer = setTimeout(() => {
        this.playNextAudio()
      }, interval)
    },
    onAudioError(e) {
      console.error('音频播放错误:', e)
      if (!this.isPlaying) {
        this.stopWaveformLoop()
      }
      if (this.isPlaying) {
        this.playNextAudio()
      }
    },
    parseDuration(durationStr) {
      const parts = durationStr.split(':')
      const minutes = parseInt(parts[0]) || 0
      const seconds = parseInt(parts[1]) || 0
      return (minutes * 60 + seconds) * 1000
    },
    getRandomInterval() {
      if (!this.randomIntervalEnabled) {
        return 0
      }
      return Math.floor(Math.random() * (this.maxInterval - this.minInterval + 1) + this.minInterval) * 1000
    },
    addAudio() {
      this.editingAudio = null
      this.currentAudio = {
        name: '',
        fileName: '',
        duration: '00:00'
      }
      this.showAudioModal = true
    },
    editAudio(audio) {
      this.editingAudio = audio
      this.currentAudio = {...audio}
      this.showAudioModal = true
    },
    deleteAudio(id) {
      if (confirm('确定要删除这个音频吗？')) {
        this.audios = this.audios.filter(a => a.id !== id)
      }
    },
    closeAudioModal() {
      this.showAudioModal = false
      this.editingAudio = null
      this.currentAudio = {
        name: '',
        fileName: '',
        duration: '00:00'
      }
    },
    saveAudio() {
      if (!this.currentAudio.name) return

      if (this.editingAudio) {
        Object.assign(this.editingAudio, this.currentAudio)
      } else {
        this.audios.push({
          id: Date.now(),
          ...this.currentAudio,
          enabled: true,
          selected: false
        })
      }
      this.closeAudioModal()
    },
    playAudio(audio) {
      if (!audio.url) {
        alert('该音频没有可播放的文件')
        return
      }
      this.initAudioContext()

      const audioPlayer = this.$store.state.fragmentsAudio
      if (this.selectedDevice && this.selectedDevice !== 'default') {
        audioPlayer.setSinkId(this.selectedDevice).catch(err => {
          console.warn('无法设置音频设备:', err)
        })
      }

      if (this.audioContext && this.effects.some(e => e.enabled)) {
        this.playWithEffects(audio)
      } else {
        audioPlayer.src = audio.url
        audioPlayer.play().catch(err => {
          console.error('播放失败:', err)
          alert('播放失败')
        })
      }
    },
    initAudioContext() {
      if (!this.audioContext) {
        this.audioContext = new (window.AudioContext || window.webkitAudioContext)()
      }
      if (this.audioContext.state === 'suspended') {
        this.audioContext.resume()
      }
    },
    playWithEffects(audio) {
      if (!this.audioContext) {
        this.audioContext = new (window.AudioContext || window.webkitAudioContext)()
      }

      if (this.audioContext.state === 'suspended') {
        this.audioContext.resume()
      }

      if (!this.audioSource) {
        this.audioSource = this.audioContext.createMediaElementSource(this.$store.state.fragmentsAudio)
      }

      this.applyEffects()

      this.$store.state.fragmentsAudio.src = audio.url
      this.$store.state.fragmentsAudio.play().catch(err => {
        console.error('播放失败:', err)
        alert('播放失败')
      })
    },
    applyEffects() {
      this.activeFilters = []
      const enabledEffects = this.effects.filter(e => e.enabled)

      let playbackRate = 1.0

      const speedEffect = enabledEffects.find(e => e.name.includes('语速变化 (x)'))
      if (speedEffect) {
        const rate = Number(speedEffect.current)
        if (Number.isFinite(rate)) {
          playbackRate = Math.max(0.5, Math.min(2.0, rate))
        }
      }

      const speedSemiEffect = enabledEffects.find(e => e.name.includes('语速变化 (半音)'))
      if (speedSemiEffect) {
        const rate = Number(speedSemiEffect.current)
        if (Number.isFinite(rate)) {
          playbackRate *= Math.max(0.5, Math.min(2.0, rate))
        }
      }

      const pitchEffect = enabledEffects.find(e => e.name.includes('音调变化 (半音)'))
      if (pitchEffect) {
        const semitone = Number(pitchEffect.current)
        if (Number.isFinite(semitone)) {
          const pitchRate = Math.pow(2, semitone / 12)
          playbackRate *= pitchRate
        }
      }
      playbackRate = Math.max(0.25, Math.min(2.0, playbackRate))

      this.$store.state.fragmentsAudio.playbackRate = playbackRate

      const filters = []
      let compressorNode = null
      let waveShaperNode = null

      if (!this.gainNode) {
        this.gainNode = this.audioContext.createGain()
      }
      try {
        this.gainNode.disconnect()
      } catch (e) {
      }
      this.waveformTapConnected = false
      this.gainNode.gain.value = 1

      const hasCompressor = enabledEffects.some(e =>
          e.name.includes('压缩阈值') ||
          e.name.includes('压缩比率')
      )

      if (hasCompressor) {
        compressorNode = this.audioContext.createDynamicsCompressor()

        const thresholdEffect = enabledEffects.find(e => e.name.includes('压缩阈值'))
        if (thresholdEffect) {
          const threshold = Number(thresholdEffect.current)
          if (Number.isFinite(threshold)) {
            compressorNode.threshold.value = threshold
          }
        }

        const ratioEffect = enabledEffects.find(e => e.name.includes('压缩比率'))
        if (ratioEffect) {
          const ratio = Number(ratioEffect.current)
          if (Number.isFinite(ratio)) {
            compressorNode.ratio.value = ratio
          }
        }

        compressorNode.knee.value = 30
        compressorNode.attack.value = 0.003
        compressorNode.release.value = 0.25
      }
      this.compressorNode = compressorNode

      const shaperEffect = enabledEffects.find(e => e.name.includes('动态重塑'))
      if (shaperEffect) {
        const amount = Math.max(0, Math.min(1, Number(shaperEffect.current) || 0))
        waveShaperNode = this.audioContext.createWaveShaper()
        waveShaperNode.curve = this.makeShaperCurve(amount)
        waveShaperNode.oversample = '2x'
        this.lastShaperAmount = amount
      } else {
        this.lastShaperAmount = null
      }
      this.waveShaperNode = waveShaperNode

      const freqBands = [
        {name: '30Hz均衡', freq: 30},
        {name: '50Hz均衡', freq: 50},
        {name: '80Hz均衡', freq: 80},
        {name: '200Hz均衡', freq: 200},
        {name: '600Hz均衡', freq: 600},
        {name: '1kHz均衡', freq: 1000},
        {name: '4kHz均衡', freq: 4000},
        {name: '8kHz均衡', freq: 8000},
        {name: '10kHz均衡', freq: 10000},
        {name: '12kHz均衡', freq: 12000}
      ]

      freqBands.forEach(band => {
        const effect = enabledEffects.find(e => e.name.includes(band.name))
        if (effect) {
          const filter = this.audioContext.createBiquadFilter()
          filter.type = 'peaking'
          filter.frequency.value = band.freq
          filter.Q.value = 1
          const gain = Number(effect.current)
          if (Number.isFinite(gain)) {
            filter.gain.value = gain
          }
          filters.push(filter)
          this.activeFilters.push(filter)
        } else {
          this.activeFilters.push(null)
        }
      })

      this.audioSource.disconnect()

      let lastNode = null

      if (filters.length > 0) {
        this.audioSource.connect(filters[0])
        for (let i = 0; i < filters.length - 1; i++) {
          filters[i].connect(filters[i + 1])
        }
        lastNode = filters[filters.length - 1]
      } else {
        lastNode = this.audioSource
      }

      if (compressorNode) {
        lastNode.connect(compressorNode)
        lastNode = compressorNode
      }

      if (waveShaperNode) {
        lastNode.connect(waveShaperNode)
        lastNode = waveShaperNode
      }

      lastNode.connect(this.gainNode)
      this.gainNode.connect(this.audioContext.destination)
      this.ensureWaveformTapFromGain()
    },
    toggleAudioStatus(audio) {
      audio.enabled = !audio.enabled
    },
    saveGroup() {
      if (!this.newGroupName) return
      this.groups.push({
        id: Date.now(),
        name: this.newGroupName
      })
      this.newGroupName = ''
      this.showGroupModal = false
    },
    importAudios() {
      const input = document.createElement('input')
      input.type = 'file'
      input.accept = '.json'
      input.onchange = (e) => {
        const file = e.target.files[0]
        if (file) {
          const reader = new FileReader()
          reader.onload = (event) => {
            try {
              const data = JSON.parse(event.target.result)
              this.audios.push(...data)
              alert('导入成功')
            } catch (error) {
              alert('导入失败：文件解析错误')
            }
          }
          reader.readAsText(file)
        }
      }
      input.click()
    },
    exportAudios() {
      const exportData = this.audios.map(({id, selected, ...a}) => a)
      const dataStr = JSON.stringify(exportData, null, 2)
      const dataBlob = new Blob([dataStr], {type: 'application/json'})
      const url = URL.createObjectURL(dataBlob)
      const link = document.createElement('a')
      link.href = url
      link.download = `音频列表_${new Date().toISOString().slice(0, 10)}.json`
      link.click()
      URL.revokeObjectURL(url)
    },
    clearAudios() {
      if (confirm('确定要清空所有音频吗？')) {
        this.audios = []
      }
    },
    toggleSelectAll() {
      this.audios.forEach(a => a.selected = this.selectAll)
    },
    saveEffects() {
      this.persistEffects()
      alert('特效设置已保存')
    },
    resetEffects() {
      this.effects = JSON.parse(JSON.stringify(this.defaultEffects))
      this.intensity = 'light'
      this.persistEffects()
      if (this.audioContext && this.audioSource && this.effects.some(e => e.enabled)) {
        this.applyEffects()
      }
    },
    toggleAllEffects() {
      if (this.allEffectsSelected) {
        this.effects.forEach(effect => {
          effect.enabled = false
        })
      } else {
        this.effects.forEach(effect => {
          effect.enabled = true
        })
      }
      this.persistEffects()
      if (this.audioContext && this.audioSource && this.effects.some(e => e.enabled)) {
        this.applyEffects()
      }
    },
    selectFolder() {
      const input = document.createElement('input')
      input.type = 'file'
      input.webkitdirectory = true
      input.multiple = this.playMode.startsWith('multi')
      input.accept = 'audio/*'
      input.onchange = (e) => {
        const files = e.target.files
        if (files && files.length > 0) {
          const filePath = files[0].webkitRelativePath
          const folderPath = filePath.split('/')[0] || files[0].name
          const audioExtensions = ['.mp3', '.wav', '.ogg', '.m4a', '.aac', '.flac']

          const audioFiles = Array.from(files).filter(file => {
            const ext = file.name.toLowerCase().slice(file.name.lastIndexOf('.'))

            return audioExtensions.includes(ext)
          })


          if (audioFiles.length === 0) {
            this.$dialog.tips({
              message: "文件夹中没有找到音频文件",
              type: 'error'
            })
            return
          }

          var audioList = {};
          for (var i in audioFiles) {
            const file = audioFiles[i];
            if (file.webkitRelativePath) {
              let filelen1 = file.webkitRelativePath.indexOf("/");

              let filelen = file.webkitRelativePath.lastIndexOf("/");

              let dir = file.webkitRelativePath.substring(filelen, filelen1 + 1);

              if (!audioList[dir]) {
                audioList[dir] = [];
              }
              const audioUrl = URL.createObjectURL(file)
              file.url = audioUrl
              audioList[dir].push(file);
              audioList[dir].sort();

              audioList[dir].sort((a, b) => {
                return a.name.localeCompare(b.name, undefined, {numeric: true, sensitivity: 'base'});
              });

            }
            // audioList[file.webkitRelativePath.substring(0,filelen)].push(files[i]);

          }

          this.audioList = audioList;

          this.DirName=folderPath;

          // console.log(audioList)
          //
          // const exists = this.audioFolders.find(f => f.name === folderPath)
          // let folderId
          //
          // if (exists) {
          //   folderId = exists.id
          // } else {
          //   folderId = Date.now()
          //   this.audioFolders.push({
          //     id: folderId,
          //     name: folderPath,
          //     path: folderPath,
          //     files: []
          //   })
          // }
          //
          // const folder = this.audioFolders.find(f => f.id === folderId)
          // folder.files = folder.files || []
          //
          // audioFiles.forEach(file => {
          //   const audioUrl = URL.createObjectURL(file)
          //   const audio = new Audio()
          //   audio.src = audioUrl
          //
          //   audio.onloadedmetadata = () => {
          //     const duration = this.formatDuration(audio.duration)
          //     const audioObj = {
          //       id: Date.now() + Math.random(),
          //       name: file.name,
          //       fileName: file.name,
          //       duration: duration,
          //       enabled: true,
          //       selected: false,
          //       url: audioUrl,
          //       file: file
          //     }
          //
          //     const existsAudio = this.audios.find(a => a.name === file.name)
          //     if (!existsAudio) {
          //       this.audios.push(audioObj)
          //     }
          //
          //     if (!folder.files.find(f => f.name === file.name)) {
          //       folder.files.push(audioObj)
          //     }
          //   }
          //
          //   audio.onerror = () => {
          //     console.warn('无法加载音频文件:', file.name)
          //   }
          // })

          // this.selectedFolder = folderId
        }
      }
      input.click()
    },
    formatDuration(seconds) {
      const mins = Math.floor(seconds / 60)
      const secs = Math.floor(seconds % 60)
      return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`
    },
    removeFolder(id) {
      const folder = this.audioFolders.find(f => f.id === id)
      if (folder) {
        folder.files.forEach(audio => {
          if (audio.url) {
            URL.revokeObjectURL(audio.url)
          }
        })
        this.audios = this.audios.filter(a => !folder.files.find(f => f.id === a.id))
      }
      this.audioFolders = this.audioFolders.filter(f => f.id !== id)
      if (this.selectedFolder === id) {
        this.selectedFolder = ''
      }
    },
    clearFolders() {
      if (confirm('确定要清空所有文件夹吗？')) {
        this.audioFolders = []
      }
    },
    handleFileSelect(e) {
      const file = e.target.files[0]
      if (file) {
        this.currentAudio.fileName = file.name
      }
    },
    previousPage() {
      if (this.currentPage > 1) {
        this.currentPage--
      }
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++
      }
    }
  }
}
</script>

<style scoped>
.audio-playback {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.panel {
  background: linear-gradient(135deg, rgba(35, 35, 35, 0.95) 0%, rgba(25, 25, 25, 0.95) 100%);
  backdrop-filter: blur(15px);
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.4);
  border: 1px solid rgba(60, 60, 60, 0.5);
  padding: 25px;
  position: relative;
  overflow: hidden;
}

.panel-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 1px solid rgba(170, 170, 170, 0.2);
}

.panel-title {
  font-size: 20px;
  font-weight: 700;
  background: linear-gradient(90deg, #c4b5fd 0%, #a5f3fc 50%, #bbf7d0 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  display: flex;
  align-items: center;
  gap: 10px;
}

.header-actions {
  display: flex;
  gap: 10px;
  align-items: center;
}

.control-settings {
  background: linear-gradient(135deg, rgba(35, 35, 35, 0.95) 0%, rgba(25, 25, 25, 0.95) 100%);
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 20px;
  border: 1px solid rgba(170, 170, 170, 0.2);
}

.setting-row {
  display: flex;
  gap: 20px;
  align-items: center;
  flex-wrap: wrap;
}

.setting-item {
  display: flex;
  align-items: center;
  gap: 10px;
}

.setting-item label {
  font-size: 14px;
  font-weight: 600;
  color: rgba(170, 170, 170, 0.9);
}

.setting-select {
  padding: 8px 12px;
  border: 1px solid rgba(170, 170, 170, 0.3);
  border-radius: 8px;
  font-size: 14px;
  background: rgba(30, 30, 30, 0.9);
  color: rgba(170, 170, 170, 0.9);
  cursor: pointer;
}

.custom-select {
  position: relative;
  min-width: 150px;
  padding: 8px 12px;
  border: 1px solid rgba(170, 170, 170, 0.3);
  border-radius: 8px;
  background: rgba(30, 30, 30, 0.9);
  color: rgba(170, 170, 170, 0.9);
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.custom-select:hover {
  border-color: rgba(170, 170, 170, 0.5);
}

.custom-select-value {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

}

.file-dir{
  position: relative;
  min-width: 200px;
  padding: 8px 12px;
  border: 1px solid rgba(170, 170, 170, 0.3);
  border-radius: 8px;
  background: rgba(30, 30, 30, 0.9);
  color: rgba(170, 170, 170, 0.9);
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.file-dir:hover{
  border-color: rgba(170, 170, 170, 0.5);

}


.select-arrow {
  font-size: 12px;
  color: rgba(170, 170, 170, 0.6);
  margin-left: 8px;
  transition: transform 0.3s ease;
}

.custom-select-dropdown {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  background: rgba(35, 35, 35, 0.98);
  border: 1px solid rgba(170, 170, 170, 0.3);
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.4);
  z-index: 100;
  overflow: hidden;
}

.dropdown-item {
  padding: 10px 12px;
  cursor: pointer;
  transition: background 0.2s ease;
}

.dropdown-item:hover {
  background: rgba(170, 170, 170, 0.1);
}

.dropdown-item.selected {
  background: rgba(139, 92, 246, 0.2);
  color: #c4b5fd;
}

.folder-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.delete-folder-btn {
  opacity: 0;
  transition: opacity 0.2s ease;
  padding: 4px 8px;
  font-size: 12px;
}

.folder-item:hover .delete-folder-btn {
  opacity: 1;
}

.frequency-control {
  display: flex;
  align-items: center;
  gap: 5px;
}

.frequency-input {
  width: 60px;
  padding: 8px 10px;
  border: 1px solid rgba(80, 80, 80, 0.5);
  border-radius: 6px;
  font-size: 14px;
  text-align: center;
  background: rgba(40, 40, 40, 0.8);
  color: rgba(170, 170, 170, 0.9);
}

.frequency-separator {
  color: rgba(170, 170, 170, 0.9);
  font-weight: 600;
}

.frequency-unit {
  font-size: 13px;
  color: rgba(170, 170, 170, 0.9);
}

.checkbox-group {
  display: flex;
  gap: 20px;
  align-items: center;
}

.folder-select {
  display: flex;
  gap: 8px;
  align-items: center;
}

.folder-select-input {
  flex: 1;
  min-width: 150px;
}

.folder-list {
  margin-top: 15px;
  padding-top: 15px;
  border-top: 1px solid rgba(60, 60, 60, 0.5);
}

.folder-list-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  font-size: 13px;
  color: rgba(170, 170, 170, 0.9);
}

.folder-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.folder-tag {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  background: rgba(80, 80, 80, 0.4);
  border-radius: 20px;
  font-size: 13px;
  color: rgba(170, 170, 170, 0.9);
}

.remove-folder {
  background: none;
  border: none;
  color: rgba(170, 170, 170, 0.9);
  font-size: 16px;
  cursor: pointer;
  padding: 0 2px;
}

.remove-folder:hover {
  color: rgba(170, 170, 170, 0.9);
}

.checkbox-item {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font-size: 14px;
  color: rgba(170, 170, 170, 0.9);
  user-select: none;
}

.checkbox-item input[type="checkbox"] {
  display: none;
}

.checkbox-item .checkbox-custom {
  width: 44px;
  height: 24px;
  background: linear-gradient(135deg, rgba(139, 92, 246, 0.3) 0%, rgba(34, 211, 238, 0.2) 100%);
  border-radius: 12px;
  position: relative;
  border: 1px solid rgba(139, 92, 246, 0.3);
  transition: all 0.35s cubic-bezier(0.4, 0, 0.2, 1);
}

.checkbox-item .checkbox-custom::before {
  content: '';
  position: absolute;
  width: 20px;
  height: 20px;
  background: linear-gradient(135deg, #a78bfa 0%, #8b5cf6 100%);
  border-radius: 50%;
  top: 1px;
  left: 1px;
  box-shadow: 0 3px 8px rgba(139, 92, 246, 0.4);
  transition: all 0.35s cubic-bezier(0.4, 0, 0.2, 1);
}

.checkbox-item input[type="checkbox"]:checked + .checkbox-custom {
  background: linear-gradient(135deg, rgba(139, 92, 246, 0.6) 0%, rgba(34, 211, 238, 0.5) 100%);
}

.checkbox-item input[type="checkbox"]:checked + .checkbox-custom::before {
  left: 21px;
  background: linear-gradient(135deg, #ffffff 0%, #e0e0e0 100%);
  box-shadow: 0 3px 8px rgba(255, 255, 255, 0.3);
}

.audios-list {
  background: linear-gradient(135deg, rgba(50, 50, 50, 0.9) 0%, rgba(40, 40, 40, 0.9) 100%);
  border-radius: 12px;
  border: 1px solid rgba(70, 70, 70, 0.5);
  margin-bottom: 20px;
  overflow: hidden;
}

.list-header {
  display: grid;
  grid-template-columns: 50px 60px 1fr 80px 80px 120px;
  gap: 10px;
  padding: 15px 20px;
  background: rgba(60, 60, 60, 0.8);
  font-weight: 600;
  font-size: 14px;
  color: rgba(170, 170, 170, 0.9);
}

.header-checkbox,
.header-index,
.header-name,
.header-duration,
.header-status,
.header-actions {
  display: flex;
  align-items: center;
}

.header-actions {
  justify-content: center;
}

.audio-item {
  display: grid;
  grid-template-columns: 50px 60px 1fr 80px 80px 120px;
  gap: 10px;
  padding: 15px 20px;
  border-bottom: 1px solid rgba(60, 60, 60, 0.5);
  transition: background 0.3s ease;
  color: rgba(170, 170, 170, 0.9);
}

.audio-item:hover {
  background: rgba(80, 80, 80, 0.5);
}

.item-checkbox,
.item-index,
.item-name,
.item-duration,
.item-status {
  display: flex;
  align-items: center;
}

.item-name {
  font-weight: 500;
}

.btn-status {
  padding: 4px 12px;
  border-radius: 20px;
  border: none;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-status.enabled {
  background: rgba(16, 185, 129, 0.3);
  color: #10b981;
}

.btn-status.disabled {
  background: rgba(80, 80, 80, 0.5);
  color: rgba(170, 170, 170, 0.7);
}

.item-actions {
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: center;
}

.btn-action {
  width: 32px;
  height: 32px;
  border-radius: 6px;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 14px;
}

.btn-action.play {
  background: rgba(139, 92, 246, 0.2);
  color: rgba(170, 170, 170, 0.9);
}

.btn-action.edit {
  background: linear-gradient(135deg, rgba(59, 130, 246, 0.4) 0%, rgba(37, 99, 235, 0.4) 100%);
  color: #93c5fd;
  border-color: rgba(147, 197, 253, 0.4);
}

.btn-action.delete {
  background: linear-gradient(135deg, rgba(239, 68, 68, 0.4) 0%, rgba(220, 38, 38, 0.4) 100%);
  color: #fca5a5;
  border-color: rgba(248, 113, 113, 0.4);
}

.empty-state {
  text-align: center;
  padding: 60px 20px;
  color: rgba(170, 170, 170, 0.7);
}

.empty-state i {
  font-size: 48px;
  margin-bottom: 15px;
  opacity: 0.5;
}

.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 15px;
  margin-top: 20px;
}

.page-info {
  font-size: 14px;
  color: rgba(170, 170, 170, 0.9);
}

.modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-content {
  background: linear-gradient(180deg, rgba(40, 40, 40, 0.98) 0%, rgba(30, 30, 30, 0.98) 100%);
  border-radius: 16px;
  width: 90%;
  max-width: 500px;
  box-shadow: 0 30px 60px rgba(0, 0, 0, 0.5), 0 0 0 1px rgba(60, 60, 60, 0.5);
  border: 1px solid rgba(60, 60, 60, 0.5);
}

.modal-header {
  padding: 20px;
  border-bottom: 1px solid rgba(60, 60, 60, 0.5);
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.modal-header h3 {
  margin: 0;
  font-size: 18px;
  color: rgba(170, 170, 170, 0.9);
}

.close-modal {
  background: none;
  border: none;
  font-size: 28px;
  color: rgba(170, 170, 170, 0.7);
  cursor: pointer;
  line-height: 1;
}

.close-modal:hover {
  color: rgba(170, 170, 170, 0.9);
}

.modal-body {
  padding: 20px;
}

.form-group {
  margin-bottom: 16px;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  font-size: 14px;
  color: rgba(170, 170, 170, 0.9);
  font-weight: 600;
}

.form-input {
  width: 100%;
  padding: 12px;
  border: 1px solid rgba(80, 80, 80, 0.5);
  border-radius: 8px;
  font-size: 14px;
  background: rgba(40, 40, 40, 0.8);
  color: rgba(170, 170, 170, 0.9);
  box-sizing: border-box;
}

.form-input::placeholder {
  color: rgba(170, 170, 170, 0.7);
}

.file-info {
  margin-top: 8px;
  font-size: 13px;
  color: rgba(170, 170, 170, 0.9);
}

.modal-footer {
  padding: 20px;
  border-top: 1px solid rgba(60, 60, 60, 0.5);
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

.btn {
  padding: 8px 16px;
  border-radius: 8px;
  border: none;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  z-index: 1;
  display: flex;
  align-items: center;
  gap: 8px;
}

.btn::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(100, 100, 100, 0.1), transparent);
  transition: left 0.5s ease;
}

.btn:hover::before {
  left: 100%;
}

.btn-success {
  background: linear-gradient(90deg, #10b981 0%, #059669 100%);
  color: #ffffff;
  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.4);
}

.btn-primary {
  background: linear-gradient(90deg, #8b5cf6 0%, #6366f1 100%);
  color: #ffffff;
  box-shadow: 0 4px 12px rgba(139, 92, 246, 0.4);
}

.btn-danger {
  background: linear-gradient(90deg, #ef4444 0%, #dc2626 100%);
  color: #ffffff;
  box-shadow: 0 4px 12px rgba(239, 68, 68, 0.4);
}

.btn-secondary {
  background: linear-gradient(135deg, rgba(107, 114, 128, 0.6) 0%, rgba(75, 85, 99, 0.6) 100%);
  color: #d1d5db;
  border: 1px solid rgba(156, 163, 175, 0.5);
}

.btn-sm {
  padding: 8px 12px;
  font-size: 14px;
}

.btn:hover {
  transform: translateY(-3px);
}

@media (max-width: 768px) {
  .header-actions {
    flex-wrap: wrap;
  }

  .setting-row {
    flex-direction: column;
    align-items: flex-start;
  }

  .list-header,
  .audio-item {
    grid-template-columns: 40px 50px 1fr;
    gap: 10px;
  }

  .list-header > div:not(:nth-child(1)):not(:nth-child(2)):not(:nth-child(3)),
  .audio-item > div:not(:nth-child(1)):not(:nth-child(2)):not(:nth-child(3)) {
    display: none;
  }

  .pagination {
    flex-direction: column;
    gap: 10px;
    text-align: center;
  }
}

.interval-box {
  display: flex;
  align-items: center;
  gap: 12px;
}

.waveform-box {
  height: 38px;
  width: 25vw;
  border-radius: 8px;
  background: linear-gradient(135deg, rgba(45, 45, 45, 0.95) 0%, rgba(35, 35, 35, 0.95) 100%);
  border: 1px solid rgba(34, 211, 238, 0.25);
  overflow: hidden;
}

.waveform-canvas {
  width: 100%;
  height: 100%;
  display: block;
}

.switch-mini {
  position: relative;
  display: inline-block;
  width: 44px;
  height: 24px;
  vertical-align: middle;
}

.switch-checkbox {
  opacity: 0;
  width: 0;
  height: 0;
}

.switch-slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, rgba(139, 92, 246, 0.3) 0%, rgba(34, 211, 238, 0.2) 100%);
  border: 1px solid rgba(139, 92, 246, 0.3);
  transition: 0.3s;
  border-radius: 24px;
}

.switch-slider:before {
  position: absolute;
  content: "";
  height: 18px;
  width: 18px;
  left: 3px;
  top: 3px;
  background: linear-gradient(135deg, #a78bfa 0%, #c4b5fd 100%);
  box-shadow: 0 2px 8px rgba(139, 92, 246, 0.4);
  transition: 0.3s;
  border-radius: 50%;
}

.switch-checkbox:checked + .switch-slider {
  background: linear-gradient(135deg, rgba(139, 92, 246, 0.5) 0%, rgba(34, 211, 238, 0.4) 100%);
  border-color: rgba(139, 92, 246, 0.5);
}

.switch-checkbox:checked + .switch-slider:before {
  left: 23px;
  background: linear-gradient(135deg, #ffffff 0%, #f0f0f0 100%);
}

.interval-inputs {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 14px;
  background: linear-gradient(135deg, rgba(45, 45, 45, 0.95) 0%, rgba(35, 35, 35, 0.95) 100%);
  border-radius: 8px;
  border: 1px solid rgba(170, 170, 170, 0.2);
  transition: all 0.3s ease;
}

.interval-inputs.active {
  background: linear-gradient(135deg, rgba(60, 60, 60, 0.95) 0%, rgba(50, 50, 50, 0.95) 100%);
  border-color: rgba(170, 170, 170, 0.3);
}

.interval-input {
  width: 55px;
  padding: 6px 10px;
  border: 1px solid rgba(170, 170, 170, 0.3);
  border-radius: 6px;
  font-size: 14px;
  text-align: center;
  background: rgba(40, 40, 40, 0.9);
  color: rgba(170, 170, 170, 0.9);
  transition: all 0.3s ease;
}

.interval-input:focus {
  outline: none;
  border-color: rgba(170, 170, 170, 0.5);
  box-shadow: 0 0 0 3px rgba(170, 170, 170, 0.1);
}

.interval-input:disabled {
  background: rgba(30, 30, 30, 0.9);
  border-color: rgba(60, 60, 60, 0.5);
  color: rgba(170, 170, 170, 0.7);
  cursor: not-allowed;
}

.interval-text {
  font-size: 13px;
  color: rgba(170, 170, 170, 0.9);
  font-weight: 500;
}

/* 效果设置样式 */
.effects-settings {
  margin-top: 20px;
  background: linear-gradient(135deg, rgba(35, 35, 35, 0.95) 0%, rgba(25, 25, 25, 0.95) 100%);
  border-radius: 12px;
  border: 1px solid rgba(170, 170, 170, 0.2);
  padding: 15px;
}

.effects-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
  padding-bottom: 12px;
  border-bottom: 1px solid rgba(170, 170, 170, 0.15);
}

.effects-actions {
  display: flex;
  gap: 8px;
}

.effects-intensity {
  display: flex;
  align-items: center;
  gap: 12px;
}

.intensity-label {
  font-size: 13px;
  color: rgba(170, 170, 170, 0.9);
  font-weight: 500;
}

.radio-label {
  font-size: 13px;
  color: rgba(170, 170, 170, 0.9);
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 4px;
}

.radio-label input[type="radio"] {
  width: 14px;
  height: 14px;
  accent-color: rgba(170, 170, 170, 0.7);
}

.effects-list {
  max-height: 320px;
  overflow-y: auto;
}

.effects-table {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
}

.table-header {
  display: none;
}

.effects-group {
  background: linear-gradient(135deg, rgba(35, 35, 35, 0.95) 0%, rgba(25, 25, 25, 0.95) 100%);
  border-radius: 10px;
  padding: 12px;
  border: 1px solid rgba(170, 170, 170, 0.2);
}

.effects-group-header {
  display: flex;
  align-items: center;
  gap: 8px;
  padding-bottom: 8px;
  border-bottom: 1px solid rgba(170, 170, 170, 0.15);
}

.effects-group-title {
  font-size: 13px;
  font-weight: 600;
  color: rgba(170, 170, 170, 0.9);
}

.table-row {
  display: flex;
  align-items: center;
  padding: 6px 8px;
  border-bottom: 1px solid rgba(170, 170, 170, 0.1);
  transition: background 0.2s;
}

.table-row:last-child {
  border-bottom: none;
}

.table-row:hover {
  background: rgba(170, 170, 170, 0.08);
  border-radius: 6px;
}

.col-checkbox {
  width: 28px;
}

.col-name {
  flex: 1;
  font-size: 12px;
  color: rgba(170, 170, 170, 0.9);
}

.col-value {
  width: 70px;
}

.effect-input {
  width: 60px;
  padding: 3px 6px;
  border: 1px solid rgba(170, 170, 170, 0.3);
  border-radius: 4px;
  font-size: 11px;
  text-align: center;
  background: rgba(30, 30, 30, 0.9);
  color: rgba(170, 170, 170, 0.9);
}

.col-effect {
  width: 100px;
  flex-shrink: 0;
}

.effect-slider {
  width: 100%;
  height: 6px;
  -webkit-appearance: none;
  appearance: none;
  background: rgba(170, 170, 170, 0.3);
  border-radius: 3px;
  outline: none;
  margin-top: 4px;
}

.effect-slider::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 14px;
  height: 14px;
  background: linear-gradient(135deg, rgba(170, 170, 170, 0.9) 0%, rgba(130, 130, 130, 0.9) 100%);
  border-radius: 50%;
  cursor: pointer;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
}

.effect-slider::-moz-range-thumb {
  width: 14px;
  height: 14px;
  background: linear-gradient(135deg, rgba(170, 170, 170, 0.9) 0%, rgba(130, 130, 130, 0.9) 100%);
  border-radius: 50%;
  cursor: pointer;
  border: none;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
}
</style>
